module.exports = __webpack_public_path__ + "static/img/dde_first_img.eb73db0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity20240117/dde_first_img.png
// module id = 9Czg
// module chunks = 0